export default __webpack_public_path__ + "static/media/not-authorized-dark.c7c1ece5.svg";